const Module = () => import('./Module.vue')
const Home = () => import('./views/Home.vue')

const moduleRoute = {
  path: '/',
  component: Module,
  children: [
    {
      path: 'statistics',
      name: 'statistics-home',
      component: Home,
    },
  ],
}

export default router => {
  router.addRoutes([moduleRoute])
}
